<template>
    <v-app id="selectLanguage">
        <tool-bar>
            <slot><h3>Visa Transfer Confirmation</h3></slot>
        </tool-bar>
        <v-content class="pt-0">
            <v-container fluid>
                <v-layout justify-center>
                    <v-card>
                        <v-toolbar class="elevation-0" color="none">
                            <v-toolbar-title>
                                <b class="text-primary">Dear {{extendConvertVisaDetail.full_name}} , please confirm your
                                    information:</b>
                            </v-toolbar-title>
                            <v-spacer/>
                        </v-toolbar>

                        <v-card-text class="pt-0">
                            <v-layout row wrap>

                                <confirmation-header-text :text="$vuetify.lang.t('$vuetify.visa_transfer_details')"
                                                          class="ml-2"
                                                          icon="mdi-equal-box"/>

                                <v-flex md3 xs6>
                                    <list-item-detail
                                        :sub_title="visaTransferData.document_type"
                                        :title="$vuetify.lang.t('$vuetify.transfer_document_type')"/>
                                </v-flex>
                                <v-flex md3 xs6>
                                    <list-item-detail
                                        :sub_title="visaTransferData.document_number"
                                        :title="visaTransferData.document_type + $vuetify.lang.t('$vuetify.transfer_document_number')"/>
                                </v-flex>
                                <v-flex md3 xs6>
                                    <list-item-detail
                                        :sub_title="visaTransferData.document_validity"
                                        :title="visaTransferData.document_type + $vuetify.lang.t('$vuetify.transfer_document_validity')"/>
                                </v-flex>

                                <v-flex md3 xs6>
                                    <list-item-detail
                                        :sub_title="'$ '+extendConvertVisaDetail.visa_transfer_cost"
                                        :title="$vuetify.lang.t('$vuetify.visa_transfer_cost')"/>
                                </v-flex>
                                <v-flex md3 xs6>
                                    <list-item-detail
                                        :sub_title="visaTransferData.reason_for_transfer"
                                        :title="$vuetify.lang.t('$vuetify.reason_for_transfer')"/>
                                </v-flex>
                              <v-flex md3 xs6 v-if="visaTransferData.recommendation_letter">
                                <label>Recommendation Letter</label>
                                <file-display :src="visaTransferData.recommendation_letter"></file-display>
                              </v-flex>
                                <v-flex xs12>
                                    <v-divider class="mt-3"/>
                                </v-flex>

                                <v-flex xs12>
                                    <visa-detail :visa="extendConvertVisaDetail"/>
                                </v-flex>

                                <v-flex class="mt-4 " xs12>
                                    <v-btn :loading="loading" @click="submit" class="pull-right" color="primary"
                                    large>
                                        Submit
                                    </v-btn>

                                    <v-btn @click="backBtnClicked" class="pull-right mr-2" color="error"
                                    large>
                                        Back
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import VisaDetail from "../VisaDetail";
    import ListItemDetail from "../../components/ListItemDetail";
    import ToolBar from "../../components/ToolBar";
    import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";
    import FileDisplay from '../../components/FileDisplay';

    export default {
        name: "TransferConfirm",
        components: {
            VisaDetail,
            ListItemDetail, ToolBar, ConfirmationHeaderText, FileDisplay
        },
        computed: {
            ...mapGetters('VisaSingle', ['visa', 'visaTransferData', 'extendConvertVisaDetail', 'loading']),
        },
        methods: {
            ...mapActions({
                submitTransferVisa: 'VisaSingle/submitTransferVisa'
            }),
            submit() {
                this.submitTransferVisa().then((res) => {
                    this.$store.commit('VisaSingle/setPrintResponse', res.data);
                    this.$router.push({
                        name: 'PrintForm'
                    })
                })
            },
            backBtnClicked() {
                this.$router.go(-1);
            },
        }
    }
</script>
